var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import { MuiVega } from './MuiVega';
/**
 * <VegaLite> from react-vega but with a Material UI integrated theme
 */
export var MuiVegaLite = forwardRef(function (props, ref) {
    return React.createElement(MuiVega, __assign({ ref: ref }, props, { mode: "vega-lite" }));
});
MuiVegaLite.displayName = 'MuiVegaLite';
